import HttpRequest from "@api/httpRequest";
import { RequestData } from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = ():string => {
    return `/categories`
};

function api() {
  return {
      getList: (data: RequestData) => {
          const {params={}} = data;
          return HttpRequest.get(getUrl(), {
              params : params
          });
      },

      create: (data: RequestData) => {
          return HttpRequest.post(
              getUrl(),
              data.payload,
              {}
          );
      },

      update : (data:RequestData) => {
          const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
          return HttpRequest.put(url, data.payload, {});
      },

      delete : (data:RequestData) => {
          const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
          return HttpRequest.delete(url, {});
      },

      getItem: (data:RequestData) => {
          const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
          return HttpRequest.get(url);
      },
  };
}

export default api();
